<div class="timetableGrid text-xs md:text-sm lg:text-base" [ngStyle]="{'grid-template-rows': gridStyle}">
  @for (day of days; track day; let i = $index) {
    <div [style.grid-column]="2+i" [style.grid-row]="1" class="timetableHeader">
      <b><edu-udo-itmc-dev-mini-book-date-display [date]="day"></edu-udo-itmc-dev-mini-book-date-display></b>
    </div>
  }
  <div [style.grid-column]="1" [style.grid-row]="1" class="timetableHeader"></div>

  @for (hour of hours; track hour; let i = $index) {
    <div [style.grid-column]="1" [style.grid-row]="i*rowsPerHour+2+'/ span '+rowsPerHour" class="timetableHeader">
      <b>{{hour}} Uhr</b>
    </div>
  }

  @for (entry of timetableEntries; track entry) {
    <div [style.grid-column]="entry.column" [style.grid-row]="entry.row" class="timetableEntry">
      <div>
        <edu-udo-itmc-dev-mini-book-time-display [time]="entry.rowEntry.timeslot.start"></edu-udo-itmc-dev-mini-book-time-display>
        -
        <edu-udo-itmc-dev-mini-book-time-display [time]="entry.rowEntry.timeslot.end"></edu-udo-itmc-dev-mini-book-time-display>
        <br>
        <span>{{ entry.rowEntry.entry.title }}</span>
        @if (noteNumberMap.has(entry.rowEntry.entry.id)) {
          <sup><b>[{{noteNumberMap.get(entry.rowEntry.entry.id)}}]</b></sup>
        }
          <br>
          <edu-udo-itmc-dev-mini-book-room-display [room]="entry.rowEntry.room" [online]="entry.rowEntry.entry.online"></edu-udo-itmc-dev-mini-book-room-display>
          @if (showInternalLink) {
            <a (click)="showTimetableEntry($event, entry.rowEntry.entry.id)" style="cursor: pointer;" href="#">Mehr Informationen</a>
          }
          @if ((!showInternalLink) && (!! entry.rowEntry.entry.furtherInformationUrl)) {
            <a class="external" style="cursor: pointer;" href="{{entry.rowEntry.entry.furtherInformationUrl}}" target="_blank">Mehr Informationen</a>
          }
        </div>
      </div>
    }

    @for (day of days; track day; let column = $index) {
      @for (hour of hours; track hour; let row = $index) {
        <span class="gridLines" [style.grid-column]="2+column" [style.grid-row]="row*rowsPerHour+2+'/ span '+rowsPerHour"></span>
      }
    }
  </div>

  @if (entryNotes.length > 0) {
    <div class="notesLegend">
      <b>Hinweise zu den Veranstaltungen:</b>
      @for (note of entryNotes; track note) {
        <div>[{{note.number}}]: {{note.text}}</div>
      }
    </div>
  }
